export default {
  data() {
    return {
      currentChecklist: 0,
      descriptionDetails: {
        checkListReportAttachments: [],
        vehicleDetails: {
          code: '',
          title: '',
          numberPlate: '',
        },
      },
      checkLists: {
        tabs: [],
      },
    };
  },
  methods: {
    onChange: function (item, x) {
      console.log(item, x);
    },
  },
};
